import { getAvailableTherapists } from "@/lib/therapist-scheduling/api";
import type {
	AvailableTherapistsParams,
	TherapistAvailabilityResponse,
} from "@/lib/therapist-scheduling/types";
import { useAbortableResource } from "./use-abortable-resource";

/**
 * Fetches all available therapists (+ embedded slots) for a date/location.
 * §8 enabled gate: date && latitude != null && longitude != null && location_id
 * && service_id. Coordinates are REQUIRED upstream for both internal and
 * external therapists (omitting them 400s "missing required fields: location
 * coordinates"). Abort/timeout/retry handled by useAbortableResource.
 */
export function useAvailableTherapists(
	params: Partial<AvailableTherapistsParams>,
) {
	const enabled =
		!!params.date &&
		params.latitude != null &&
		params.longitude != null &&
		!!params.location_id &&
		!!params.service_id;

	return useAbortableResource<TherapistAvailabilityResponse>(
		(signal) =>
			getAvailableTherapists(params as AvailableTherapistsParams, { signal }),
		{ enabled, key: JSON.stringify(params) },
	);
}
